export const TableName = {
    Area: "city",
    Camera: "camera",
    View: "view",
    ViewPom: "viewPom",
    ViewPomPro: "pomPro",
    DisplayPom: "displayPom",
    DisplayView: "displayView",
    Category: "category",
    SubCategory: "subCategory",
    ChangePassword: "change-password",
    CustomView: "customView",
    Customer: "customer",
    DashboardLayout: "dashboardLayout",
    Event: "event",
    ExternalSource: "externalSource",
    GroupView: "groupView",
    Location: "location",
    MapLocation: "mapLocation",
    Manage: "manage",
    Pom: "pom",
    Profile: "profile",
    HeadcounterGroup: "headcounterGroup",
    HeadcounterSensor: "head-counter",
    HeadcounterLogger: "headcounterLogger",
    History: "history",
    Industry: "industry",
    Province: "province",
    Region: "region",
    SoftwareVersion: "softwareVersion",
    Tag: "tag",
    Ticketing: "ticketing",
    TicketingBySensor: "ticketingBySensor",
    TicketingByLocation: "ticketingByLocation",
    User: "user",
    ViewWelcomePage: "welcomePage",
    ViewDeep: "viewDeep",
    UserGroup: "UserGroup",
    LegalInfo: "privacy_section",
    LocationStatus: 'LOCATION_STATUS',
    Impersonation: 'impersonation',
    CustomerOverview: 'customerOverview',
}

export type TableNameType = typeof TableName[keyof typeof TableName];